/**
 * INVENTA API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PaymentAccountExtendedRequestDto { 
    fakturaCustomerRefNoFilter?: Array<number>;
    connectedUserAccountIdFilter?: Array<number>;
    invoiceStatus?: PaymentAccountExtendedRequestDto.InvoiceStatusEnum;
    balanceStatus?: PaymentAccountExtendedRequestDto.BalanceStatusEnum;
    prePostStatus?: PaymentAccountExtendedRequestDto.PrePostStatusEnum;
    accountNameFilter?: string;
    fakturaCustomerRefNoSearch?: Array<number>;
    userSearch?: Array<number>;
    accountNameSearch?: Array<string>;
    internalCommentSearch?: Array<string>;
    customerRefNoAndAccountNumberSearch?: Array<string>;
    paymentAccountIdFilter?: Array<number>;
    activeFilter?: boolean;
    confirmedFilter?: boolean;
    deviceIdsFilter?: Array<number>;
}
export namespace PaymentAccountExtendedRequestDto {
    export const InvoiceStatusEnum = {
        Open: 'OPEN',
        Overdue: 'OVERDUE'
    } as const;
    export type InvoiceStatusEnum = typeof InvoiceStatusEnum[keyof typeof InvoiceStatusEnum];
    export const BalanceStatusEnum = {
        Positive: 'POSITIVE',
        Negative: 'NEGATIVE',
        LastsLessThan2Months: 'LASTS_LESS_THAN_2_MONTHS'
    } as const;
    export type BalanceStatusEnum = typeof BalanceStatusEnum[keyof typeof BalanceStatusEnum];
    export const PrePostStatusEnum = {
        Pre: 'PRE',
        Post: 'POST'
    } as const;
    export type PrePostStatusEnum = typeof PrePostStatusEnum[keyof typeof PrePostStatusEnum];
}


export type InvoiceStatusEnum = typeof PaymentAccountExtendedRequestDto.InvoiceStatusEnum[keyof typeof PaymentAccountExtendedRequestDto.InvoiceStatusEnum];
export type BalanceStatusEnum = typeof PaymentAccountExtendedRequestDto.BalanceStatusEnum[keyof typeof PaymentAccountExtendedRequestDto.BalanceStatusEnum];
export type PrePostStatusEnum = typeof PaymentAccountExtendedRequestDto.PrePostStatusEnum[keyof typeof PaymentAccountExtendedRequestDto.PrePostStatusEnum];
